import nextSvg from '../../../assets/svg/angle-right.svg';
import prevSvg from '../../../assets/svg/angle-left.svg'


const CreditSwiper = function( swiper ) {
	if ( ! swiper ) {
		return;
	}
    window.onload = function() {
        $(".form-control").select2({width: '100%',placeholder: "All Card Features",
        allowClear: false});
    }
   
    const refreshSlider = (swiper, slides) => {
        swiper.removeAllSlides();
        var index =1;
        slides.forEach(function(elm) { 
            swiper.addSlide(index, elm);
            index ++;
        });
        var goal = $("input[type='radio'][name='creditFinder']:checked").val();
        Array.from( document.querySelectorAll( '.credit-finder-slider' ) ).map( ( feeds ) => {
            var i = 0;
            var slidertoRemove =[];
            swiper.removeAllSlides();//Remove all slide that are currently showing and update
            swiper.update();
            //Append all avaialble slides to swiper and update
            slides.forEach(function(elm) { 
                swiper.appendSlide(elm)
            });
            swiper.update();
            //Get the index list of all slides to remove and update
            slides.forEach(function(elm) { 
                if(elm.getAttribute('data-goals').indexOf(goal) == - 1)
                    slidertoRemove.push(i);
                    i++;
            });

            // swiper.removeSlide(slidertoRemove);
            // swiper.update();
            //

            var filter =$(".creditdrp").val();
            filter.forEach(function(f) { 
            var j = 0;
                slides.forEach(function(elm) { 
                    if(elm.getAttribute('data-features').indexOf(f) == -1){
                        if(slidertoRemove.indexOf(j) == -1)
                            slidertoRemove.push(j);
                    }
                    j++;
                });
            });

            swiper.removeSlide(slidertoRemove);
            swiper.update();

            if(swiper.slides.length == 0)
                swiper.appendSlide(`<article  class="products type-products status-publish hentry product_type-credit-cards excerpt excerpt--products credit-slide credit-finder-slide swiper-slide swiper-slide-visible swiper-slide-active" style="width: 350px; margin-right: 30px;">
           
                    <figure class="excerpt__product"><picture><img loading="lazy" src="../wp-content/themes/first-citizens/assets/img/credit-default.png" srcset="" alt="" height="" width=""></picture></figure>
                    <div class="excerpt__wrap">
                        <h4 class="excerpt__title">Your search did not yield a result.</h4>
                        <div class="excerpt__content">
                            <div class="excerpt__excerpt">
                            <p>We invite you to explore our range of credit cards and find the one most suitable for you.</p>
                            </div>
                        </div>
                    </div>
                </article>`)
                swiper.update();
// to get transition effect on initial slide.
                swiper.slideTo(1, 100, true);
                swiper.update();
            swiper.slideTo(0, 100, true);
            swiper.update();

        });
    }

    const renderSliders = () => {
        Array.from( document.querySelectorAll( '.credit-finder-slider' ) ).map( ( feeds ) => {
            const wrap   = feeds.querySelector('.credit-finder-slider__wrap');
            const items  = feeds.querySelector('.credit-finder-slider__items');
            const slides = Array.from( feeds.querySelectorAll('.credit-finder-slide') );
            
            wrap.classList.add('swiper-container');
            items.classList.add('swiper-wrapper');
            slides.forEach(feed => feed.classList.add('swiper-slide'));
            if (slides.length > 1) {
                feeds.insertAdjacentHTML(
                    'beforeend',
                    `<nav class="credit-finder__nav">
                        <div class="credit-swiper-button-prev">${prevSvg}<span class= "credit-finder__pagination"><span class="swiper-pagination-current"></span></span></div>
                        <div class="divider"></div>
                        <div class="credit-swiper-button-next"><span class= "credit-finder__pagination"><span class="swiper-pagination-total"></span></span>${nextSvg}</div>              
                    </nav>`
                
                );
            }
            const swiper = new window.Swiper( wrap, {
                direction: 'horizontal',
                // effect: 'fade',
                // observer: true,
                // observeParents: true,
                // autoHeight: false,
                speed: 600,
                spaceBetween: 30,
                slidesPerView: 1,
                // centeredSlides: true,
                // freeMode: false,
                // watchSlidesVisibility: true,
                watchSlidesProgress: true,
                navigation: {
                    prevEl: '.credit-finder__nav .credit-swiper-button-prev',
                    nextEl: '.credit-finder__nav .credit-swiper-button-next',
                },
                pagination: {
                    el: ".credit-finder__pagination",
                    type: "fraction",
                    formatFractionCurrent: function (number) {
                        return ('0' + number).slice(-2);
                    },
                    formatFractionTotal: function (number) {
                        return ('0' + number).slice(-2);
                    },
                    renderFraction: function (currentClass, totalClass) {
                        return '<span class="' + currentClass + '"></span>' +
                        '<span class="' + totalClass + '"></span>';
                    }
                    // renderBullet: function (index, className) {
                    //     return '<div class="pagination__text ' + className + ' "><span class="pagination-index">'+ ('0' + (index + 1).toString().slice(-5)) + '</span></div>';
                    // }
                },
                // watchOverflow: true,
                breakpoints: {
                    700: {
                        slidesPerView: 1,
                    },
                    768: {
                        slidesPerView: 1,
                    },
                    992: {
                        slidesPerView: 1,
                    }
                }
            } );
            $('.creditdrp').on("select2:select", function(e) { 
                refreshSlider(swiper,slides);  
            });

            $('.creditdrp').on("select2:unselect", function(e) { 
                refreshSlider(swiper,slides);  
            });

            var rad = document.creditFinderForm.creditFinder;
            var prev = null;
            for (var i = 0; i < rad.length; i++) {
                rad[i].addEventListener('change', function() {
                    // (prev) ? console.log(prev.value): null;
                    // if (this !== prev) {
                    //     prev = this;
                    // }
                    // if(this == prev)
                    //     this.checked = false;
                    refreshSlider(swiper,slides);  
                });
            }
        });
    }

    renderSliders();
}

CreditSwiper.instances = [].map.call( document.querySelectorAll('.credit-finder-slider'), node => CreditSwiper( node ) );

export default CreditSwiper;